<div class="adm-page">

  <header class="adm-page__header">
    <div class="adm-page__header-left">
      <div class="adm-page__icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/>
        </svg>
      </div>
      <div>
        <h1 class="adm-page__title">Utilisateurs</h1>
        <p class="adm-page__desc">Gérez les utilisateurs de votre application.</p>
      </div>
    </div>
    <app-ui-button
      label="Ajouter un utilisateur"
      variant="primary"
      size="md"
      iconLeft="add_circle_outline"
      type="button"
      (clicked)="openAddEntityModal()"
    ></app-ui-button>
  </header>

  <div class="adm-card">
    @if (isLoading) {
      <div class="adm-loader-wrapper">
        <app-loaderIntervantion [isLoading]="isLoading" [rows]="6"></app-loaderIntervantion>
      </div>
    } @else {
      <div class="adm-card__toolbar">
        <div class="adm-card__toolbar-left">
          <span class="adm-badge">{{ entities.length }}</span>
          <span class="adm-card__count">utilisateur{{ entities.length > 1 ? 's' : '' }} enregistré{{ entities.length > 1 ? 's' : '' }}</span>
        </div>
      </div>

      @if (!entities.length) {
        <div class="adm-empty">
          <div class="adm-empty__icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/>
              <circle cx="9" cy="7" r="4"/>
            </svg>
          </div>
          <p class="adm-empty__title">Aucun utilisateur</p>
          <p class="adm-empty__hint">Commencez par en ajouter un en cliquant sur le bouton ci-dessus.</p>
        </div>
      } @else {
        <app-ui-table [columns]="tableEntity" [data]="entities" [actions]="rowActions"/>
      }
    }
  </div>

  <ng-template #rowActions let-item="item">
    <div class="adm-row-actions">
      <app-ui-button iconOnly="edit" variant="ghost" size="sm" ariaLabel="Modifier" type="button" (clicked)="onEditEntity(item)"></app-ui-button>
      <app-ui-button iconOnly="delete" variant="danger" size="sm" ariaLabel="Supprimer" type="button" (clicked)="openDeleteConfirm(item)"></app-ui-button>
    </div>
  </ng-template>

</div>

<app-confirm-dialog
  [isVisible]="showDeleteConfirm"
  [itemLabel]="selectedItem?.identifiant || ''"
  [isLoading]="deleteLoading"
  (confirmed)="confirmDelete()"
  (cancelled)="cancelDelete()"
></app-confirm-dialog>

<app-modal
  [isVisible]="showAddEntityModal"
  [title]="isEditing ? 'Modifier l\'utilisateur' : 'Nouvel utilisateur'"
  (closeEvent)="closeAddEntityModal()"
>
  <form [formGroup]="entityForm" (ngSubmit)="saveEntity()" class="adm-form">

    @if (isEditing && editingEntity) {
      <div class="adm-edit-banner">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
          <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
        </svg>
        Modification de <strong>{{ editingEntity.identifiant }}</strong>
      </div>
    }

    <div class="adm-form__field">
      <app-select label="Agent" [options]="agents" formControlName="agent"/>
    </div>
    <div class="adm-form__field">
      <app-input label="Identifiant" placeholder="Ex : john.doe" type="text" formControlName="identifiant"/>
      @if (entityForm.get('identifiant')?.invalid && (entityForm.get('identifiant')?.dirty || entityForm.get('identifiant')?.touched)) {
        <span class="adm-form__error">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          L'identifiant est requis.
        </span>
      }
    </div>
    <div class="adm-form__field">
      <app-input label="Mot de passe" type="password" formControlName="motDePasse"/>
      @if (entityForm.get('motDePasse')?.invalid && (entityForm.get('motDePasse')?.dirty || entityForm.get('motDePasse')?.touched)) {
        <span class="adm-form__error">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          Le mot de passe est requis.
        </span>
      }
    </div>
    <div class="adm-form__field">
      <app-select label="Profil" [options]="profils" formControlName="profil"/>
    </div>

    <div class="adm-form__actions">
      <app-ui-button label="Annuler" variant="ghost" size="md" type="button" (clicked)="closeAddEntityModal()"></app-ui-button>
      <app-ui-button
        [label]="isEditing ? 'Mettre à jour' : 'Enregistrer'"
        variant="primary" size="md"
        [iconLeft]="isEditing ? 'check' : 'save'"
        type="submit"
        [loading]="isLoading"
        [disabled]="isLoading || entityForm.invalid"
      ></app-ui-button>
    </div>

  </form>
</app-modal>